import { Button } from '@gsa/afp-component-library';
import PropTypes from 'prop-types';
import React from 'react';
import AttachmentEditForm from './AttachmentEditForm';
import AttachmentModal from './AttachmentModal';
import { useAttachmentComponent } from './ComponentContext';

const AttachmentEdit = ({ title = 'Edit description' }) => {
  const { updating, editState, resetEditState } = useAttachmentComponent();

  return (
    <AttachmentModal
      id="attachment-edit-modal"
      title={<h3>{title}</h3>}
      show={editState?.show}
      onClose={resetEditState}
      actions={
        <>
          <Button
            disabled={updating}
            type="button"
            variant="unstyled"
            onClick={resetEditState}
            data-testid="attachment-cancel"
            label="Cancel"
          />

          <Button
            disabled={updating}
            type="submit"
            form="attachment-edit-form"
            className="edit-document-button action-button"
            label={
              editState?.field === 'effectiveDate'
                ? 'Submit date'
                : 'Submit description'
            }
          />
        </>
      }
    >
      <AttachmentEditForm />
    </AttachmentModal>
  );
};

AttachmentEdit.propTypes = {
  title: PropTypes.string,
};

export default AttachmentEdit;
